import { QuestionProps } from '@zapier/design-system-revenue/src/types';

/**
 * The server expects a very specific format here. Example output:
 *
 * 'Checked: Too expensive\nChecked: Lost my job\nComments: This is a comment'
 **/
export const formatDowngradeSurveyFeedbackAsString = (
  options: Array<QuestionProps>,
  comments: string = ''
): string => {
  // include '\n' on every why line including the last line.
  const reasons = options
    .filter(o => o.isChecked)
    .map(o => `Checked: ${o.question}\n`)
    .join('');

  return `${reasons}Comments: ${comments}`;
};
